import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from './useAppDispatch';
import { logout } from '../redux/auth/authSlice';

export const useLogout = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const handleLogout = useCallback(async () => {
    try {
      console.log('Logging out: Removing tokens and dispatching logout action');
      
      // ローカルストレージからトークンとリフレッシュトークンを削除
      localStorage.removeItem('token');
      localStorage.removeItem('refresh_token');
      
      // Reduxステートをクリア
      await dispatch(logout());
      
      // ログインページにリダイレクト
      navigate('/login');
    } catch (error) {
      console.error('Logout failed:', error);
      
      // エラーが発生した場合でも、トークンとリフレッシュトークンは削除
      localStorage.removeItem('token');
      localStorage.removeItem('refresh_token');
      
      if (!window.location.pathname.includes('/login')) {
        navigate('/login');
      }
    }
  }, [dispatch, navigate]);

  return handleLogout;
};
